<template>
  <div class="wrapper">
    <div class="box">
      <h2>Prijava</h2>
      <div class="content">
        <label>Lozinka</label>
        <input v-model="password" type="password">
        <span v-if="error" class="error">Lozinka nije ispravna</span>
        <button @click="login()">Prijavi se</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      password: null,
      error: false
    }
  },

  methods: {
    login () {
      const passwords = ['w52WbxSf201', 'NpUgl31R*neEk5f']
      if (passwords.includes(this.password)) {
        localStorage.setItem('token', '4af584ff5b785b6b94d81fd19e642187')
        this.$emit('login')
      } else {
        this.error = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #FAFAFA;
  .box {
    width: 100%;
    max-width: 400px;
    background-color: #fff;
    border: 1px solid rgba(0, 0, 0, .1);
    border-radius: 5px;
    h2 {
      line-height: 50px;
      font-size: 22px;
      border-bottom: 1px solid rgba(0, 0, 0, .1);
      text-align: center;
    }
    .content {
      padding: 30px 50px;
      text-align: center;
      label {
        display: block;
        margin-bottom: 10px;
      }
      input {
        width: 100%;
        height: 30px;
        text-align: center;
        border-radius: 5px;
        border: 1px solid rgba(0, 0, 0, .1);
      }
      .error {
        display: block;
        margin-top: 5px;
        color: rgb(214, 38, 38);
      }
      button {
        padding: 10px 40px;
        border: none;
        background-color: #000;
        color: #fff;
        border-radius: 5px;
        margin-top: 20px;
        cursor: pointer;
      }
    }
  }
}
</style>
